import { render, staticRenderFns } from "./area-recommend.vue?vue&type=template&id=723b330f&scoped=true"
import script from "./area-recommend.vue?vue&type=script&lang=ts&setup=true"
export * from "./area-recommend.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./area-recommend.vue?vue&type=style&index=0&id=723b330f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b330f",
  null
  
)

export default component.exports